export const requestConstants = {
    STATUS_CREATED: 1,
    STATUS_APPROVED: 2,
    STATUS_REJECTED: 3,
    STATUS_EXPIRED: 4,

    TYPE_SCHEDULED: 0,
    TYPE_ADDITIONAL: 1,
    TYPE_FULLDAY: 2,
    TYPE_START: 3,
    TYPE_UNLOCK: 4,
    
    CREATE_REQUEST: 'REQUEST_CREATE_REQUEST',
    CREATE_SUCCESS: 'REQUEST_CREATE_SUCCESS',
    CREATE_FAILURE: 'REQUEST_CREATE_FAILURE',

    UPDATE_REQUEST: 'REQUEST_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'REQUEST_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'REQUEST_UPDATE_FAILURE',

    REMOVE_REQUEST: 'REQUEST_REMOVE_REQUEST',
    REMOVE_SUCCESS: 'REQUEST_REMOVE_SUCCESS',
    REMOVE_FAILURE: 'REQUEST_REMOVE_FAILURE',

    FETCH_REQUEST: 'REQUEST_FETCH_REQUEST',
    FETCH_SUCCESS: 'REQUEST_FETCH_SUCCESS',
    FETCH_FAILURE: 'REQUEST_FETCH_FAILURE',

    GET_REQUEST: 'REQUEST_GET_REQUEST',
    GET_SUCCESS: 'REQUEST_GET_SUCCESS',
    GET_FAILURE: 'REQUEST_GET_FAILURE',

    APPROVE_REQUEST: 'REQUEST_APPROVE_REQUEST',
    APPROVE_SUCCESS: 'REQUEST_APPROVE_SUCCESS',
    APPROVE_FAILURE: 'REQUEST_APPROVE_FAILURE',

    REJECT_REQUEST: 'REQUEST_REJECT_REQUEST',
    REJECT_SUCCESS: 'REQUEST_REJECT_SUCCESS',
    REJECT_FAILURE: 'REQUEST_REJECT_FAILURE',
};
